<div
  class="left-right-list__entry c-digital-copy"
  *ngIf="
    !isPlayerLink &&
    (onlineResource.type !== OnlineResourceUrlType.DOI || !hideDoiLinks)
  "
>
  <div class="qa-label" [ngSwitch]="onlineResource.type">
    <ng-container
      *ngSwitchCase="OnlineResourceUrlType.DOI"
      i18n="@@digitalCopy-label-doi"
    >
      DOI
    </ng-container>
    <ng-container *ngSwitchDefault i18n="@@digitalCopy-label-digitalCopy">
      {normalisedResourceType, select, book {Book} chapter {Chapter} article
      {Article} journal {Journal} other {Digital copy}}
    </ng-container>
  </div>
  <div>
    <a
      class="btn btn-xs btn-default"
      [href]="relativeToBaseUri(onlineResource.external_url)"
      [title]="onlineResource.original_url"
      (click)="trackExternalLinkClick()"
      target="_blank"
      rel="noopener"
    >
      <ng-container [ngSwitch]="onlineResource.type">
        <ng-container
          *ngSwitchCase="OnlineResourceUrlType.OPENURL"
          i18n="@@digitalCopy-btn-checkForFullText"
        >
          Check for full text
        </ng-container>
        <ng-container
          *ngSwitchCase="OnlineResourceUrlType.OPEN_ACCESS"
          i18n="@@digitalCopy-btn-openaccess"
        >
          Open Access
        </ng-container>
        <ng-container *ngSwitchDefault i18n="@@digitalCopy-btn-availableOnline">
          Available online
        </ng-container>
      </ng-container>
    </a>
  </div>
</div>

<div
  *ngIf="isPlayerLink"
  class="left-right-list__entry c-digital-copy qa-player-link"
>
  <div class="qa-label" i18n="@@digitalCopy-label-talisElevate">
    Talis Elevate
  </div>

  <div>
    <a
      class="btn btn-xs btn-default"
      [href]="relativeToBaseUri(onlineResource.external_url)"
      [title]="onlineResource.original_url"
      (click)="trackExternalLinkClick()"
      target="_blank"
      rel="noopener"
      i18n="@@digitalCopy-btn-talisElevate"
    >
      Available online
    </a>
  </div>
</div>
